import React, { useState, useEffect } from 'react'
import { Modal, TextInput, Group, Button, ScrollArea, Text } from '@mantine/core'
import { createCurrency, updateCurrency } from '../../../../services/currency'
import { notifications } from '@mantine/notifications'

const ModalCurrency = ({ opened, onClose, isEdit, data, onSuccess }) => {
    const [formData, setFormData] = useState({
        currency_code: '',
        currency_code_target: '',
        value: ''
    })
    const [submitting, setSubmitting] = useState(false)

    useEffect(() => {
        if (isEdit && data) {
            setFormData({
                currency_code: data.attributes.currency_code,
                currency_code_target: data.attributes.currency_code_target,
                value: data.attributes.value
            })
        } else {
            setFormData({
                currency_code: '',
                currency_code_target: '',
                value: ''
            })
        }
    }, [isEdit, data, opened])

    const handleSubmit = async () => {
        if (!formData.currency_code || !formData.currency_code_target || !formData.value) {
            notifications.show({ title: 'Validation', message: 'All fields are required', color: 'yellow' })
            return
        }

        setSubmitting(true)
        try {
            if (isEdit) {
                await updateCurrency(data.id, formData)
                notifications.show({ title: 'Success', message: 'Currency rate updated successfully', color: 'green' })
            } else {
                await createCurrency(formData)
                notifications.show({ title: 'Success', message: 'Currency rate added successfully', color: 'green' })
            }
            onSuccess()
            onClose()
        } catch (error) {
            console.error(error)
            notifications.show({ title: 'Error', message: `Failed to ${isEdit ? 'update' : 'add'} currency rate`, color: 'red' })
        } finally {
            setSubmitting(false)
        }
    }

    return (
        <Modal
            opened={opened}
            onClose={onClose}
            title={<Text fw='bold'>{isEdit ? "Edit Currency Rate" : "Add New Currency Rate"}</Text>}
            centered
            size="md"
            scrollAreaComponent={ScrollArea.Autosize}
            closeOnClickOutside={false}
        >
            <TextInput
                label="Currency Code (From)"
                placeholder="e.g. IDR"
                mb="sm"
                value={formData.currency_code}
                onChange={(e) => setFormData({ ...formData, currency_code: e.target.value })}
            />
            <TextInput
                label="Currency Code Target (To)"
                placeholder="e.g. USD"
                mb="sm"
                value={formData.currency_code_target}
                onChange={(e) => setFormData({ ...formData, currency_code_target: e.target.value })}
            />
            <TextInput
                label="Value"
                placeholder="e.g. 16750"
                mb="lg"
                type="number"
                value={formData.value}
                onChange={(e) => setFormData({ ...formData, value: e.target.value })}
            />

            <Group justify="flex-end" mt="xl">
                <Button variant="default" onClick={onClose}>Cancel</Button>
                <Button onClick={handleSubmit} loading={submitting}>{isEdit ? 'Update' : 'Save'}</Button>
            </Group>
        </Modal>
    )
}

export default ModalCurrency
